import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18263 9970"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#2b2a29;fill-rule:nonzero}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="m6860 8715-460-1210H2479l-460 1234c-180 483-332 809-461 977-125 169-334 254-624 254-245 0-462-90-651-269C95 9521 0 9317 0 9090c0-133 23-270 65-409 45-141 117-335 218-586l2466-6260c71-180 154-395 253-647 99-254 205-463 317-629s258-301 440-404S4165 0 4433 0c274 0 501 52 682 155 182 103 328 236 441 397 112 162 206 337 282 524 77 186 175 435 292 745l2520 6222c197 474 296 818 296 1033 0 223-92 429-278 615-187 187-413 279-676 279-153 0-285-27-395-83-108-54-200-128-277-222-74-95-152-241-238-434-87-195-159-368-222-516zM2993 6036h2881L4421 2062 2993 6036z"
        className="fill"
      />
      <path
        id={1}
        d="M18263 6761c0 308-74 640-227 997-151 357-389 707-714 1051-324 346-739 624-1242 840-505 213-1093 321-1765 321-507 0-970-47-1388-144-415-96-795-247-1133-451-340-202-654-471-939-804-254-303-472-640-651-1015-180-375-315-777-405-1201-89-427-134-878-134-1356 0-775 112-1471 339-2084 224-616 550-1141 970-1577 422-435 914-768 1480-997 566-226 1170-341 1810-341 781 0 1475 155 2086 467 608 310 1075 696 1401 1154 323 458 487 890 487 1298 0 225-81 420-238 593-157 171-348 256-573 256-249 0-438-61-561-178-126-119-265-323-418-612-256-479-554-836-898-1074-346-236-768-355-1273-355-804 0-1442 306-1918 914-476 611-714 1478-714 2601 0 750 106 1374 317 1872 209 499 507 869 893 1116 387 245 838 369 1357 369 561 0 1035-139 1423-418 389-279 681-687 878-1228 84-254 187-461 310-622 122-160 319-241 591-241 233 0 433 81 599 245 167 162 250 364 250 604z"
        className="fill"
      />
    </g>
  </svg>
)
export default SvgComponent
